
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"104","height":"104","viewBox":"0 0 104 104","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"52","cy":"52","r":"52","fill":"#67D182"}}),_c('path',{attrs:{"d":"M71 43H58.38l1.9-9.14.06-.64c0-.82-.34-1.58-.88-2.12L57.34 29 44.18 42.18A3.91 3.91 0 0043 45v20c0 2.2 1.8 4 4 4h18c1.66 0 3.08-1 3.68-2.44l6.04-14.1c.18-.46.28-.94.28-1.46v-4c0-2.2-1.8-4-4-4zm0 8l-6 14H47V45l8.68-8.68L53.46 47H71v4zm-40-6h8v24h-8V45z","fill":"#fff"}})])
          )
        }
      }
    